import styled from 'styled-components'

interface ReviewItemMobileProps {
  postTitle: string
  userNickname: string
}

const ReviewItemMobile = ({
  postTitle,
  userNickname,
}: ReviewItemMobileProps) => {
  return (
    <StyledWrapper>
      <p className="post-title">{postTitle}</p>
      <p className="user-nickname">{userNickname}</p>
    </StyledWrapper>
  )
}

export default ReviewItemMobile

const StyledWrapper = styled.button`
  cursor: pointer;
  width: 100%;
  height: 48px;
  padding: 0px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  border-top: 1px solid #eeeeee;

  > .post-title {
    max-width: 80%;
    text-align: left;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: -0.6px;
    text-align: left;
    color: #333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  > .user-nickname {
    width: 80px;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: -0.6px;
    text-align: left;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
